import React from "react";
import { Phone, CalendarCheck, FileText } from "lucide-react";
import { useLead } from "./LeadDialog";
import { CONTACT } from "../data/site";

const StickyMobileCTA = () => {
  const { openLead } = useLead();
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-border shadow-[0_-10px_40px_rgba(0,0,0,0.1)]"
      data-testid="sticky-mobile-cta"
    >
      <div className="grid grid-cols-3 divide-x divide-border">
        <a
          href={CONTACT.phoneHref}
          className="flex flex-col items-center justify-center gap-1 py-3 text-jet-ink active:bg-muted"
          data-testid="mobile-sticky-call"
        >
          <Phone className="h-5 w-5 text-jet-teal" />
          <span className="text-[11px] font-bold">Call</span>
        </a>
        <button
          onClick={() => openLead("booking")}
          className="flex flex-col items-center justify-center gap-1 py-3 text-jet-ink active:bg-muted"
          data-testid="mobile-sticky-book"
        >
          <CalendarCheck className="h-5 w-5 text-jet-teal" />
          <span className="text-[11px] font-bold">Book Online</span>
        </button>
        <button
          onClick={() => openLead("quote")}
          className="flex flex-col items-center justify-center gap-1 py-3 bg-jet-teal text-white active:bg-jet-teal-deep"
          data-testid="mobile-sticky-quote"
        >
          <FileText className="h-5 w-5" />
          <span className="text-[11px] font-bold">Request Quote</span>
        </button>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
